/**
 * The gantt's rows: the shared view-rows request at the gantt's address.
 *
 * A gantt pages by `limit`/`offset` like a gallery or a list: what it does with
 * the rows is different, but what it asks for is not. Its axis is a range the
 * reader is looking at rather than anything derived from the page, so the
 * request carries no dates -- see `timeline.ts`.
 */
import { viewRowsFetcher } from '../views/view-rows'

const gantt = viewRowsFetcher('/api/database/views/gantt/{view_id}/')

export const fetchGanttRows = gantt.fetch
export const __setGanttRowFetcherForTests = gantt.setForTests
